import React from 'react';
import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { usePermissions } from '@/providers/Permissions.provider';
import { usePartnerData } from '@/providers/PartnerData.provider';
import PartnerCreationPage from './PartnerCreation/PartnerCreationPage';
import PartnerList from './PartnerList/PartnerList';
import LegacyPartnerDetailsPage from './PartnerDetails/PartnerDetailsPage';
import PartnerManagementPage from './PartnerManagement/PartnerManagementPage';
import PartnerDetailsPage from './PartnerManagement/PartnerDetailsPage/PartnerDetailsPage';
import { PARTNER_MANAGEMENT_PATH } from './PartnerManagement/paths';
import * as partnerPageRoute from './PartnerManagement/partnerPage.route';

const Routes = (): React.JSX.Element => {
  const { permissions } = usePermissions();

  const {
    response: { isRoleAdmin },
  } = usePartnerData();

  const isAllowed = isRoleAdmin && permissions.PartnerCreationEnabled;

  return (
    <Switch>
      <ProtectedRoute isAllowed={isAllowed} showPermission exact path="/partners-create">
        <PartnerCreationPage />
      </ProtectedRoute>

      <ProtectedRoute isAllowed={isAllowed} showPermission exact path="/partners">
        <PartnerList />
      </ProtectedRoute>

      <ProtectedRoute isAllowed={isAllowed} showPermission exact path={PARTNER_MANAGEMENT_PATH}>
        <PartnerManagementPage />
      </ProtectedRoute>

      <ProtectedRoute isAllowed={isAllowed} showPermission exact path={partnerPageRoute.path}>
        <PartnerDetailsPage />
      </ProtectedRoute>

      <ProtectedRoute isAllowed={isAllowed} showPermission path="/partners/:partnerAccountId">
        <LegacyPartnerDetailsPage />
      </ProtectedRoute>
    </Switch>
  );
};

export default Routes;
